<template>
<div class="container">
  <div class="main">
    <div class="thumb-example">

      <swiper class="swiper gallery-top" :options="swiperOptionTop" ref="swiperTop">
        <swiper-slide class="slide-2"
          v-for="(item,i) in picData" :key="i"
          :style="{ 'background-image': 'url('+ item +')'}"
        ></swiper-slide>
        <div class="swiper-button-next swiper-button-white" slot="button-next"></div>
        <div class="swiper-button-prev swiper-button-white" slot="button-prev"></div>
      </swiper>
      <!-- swiper2 Thumbs -->
      <swiper class="swiper gallery-thumbs" :options="swiperOptionThumbs" ref="swiperThumbs">
        <swiper-slide class="slide-2" v-for="(item,i) in picData" :key="i"
          :style="{ 'background-image': 'url('+ item +')'}">
        </swiper-slide>
      </swiper>

    </div>
  </div>
</div>

</template>

<script>
  import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
  import 'swiper/css/swiper.css'
  export default {
    name: 'swiper-example-thumbs-gallery',
    title: 'Thumbs gallery with Two-way control',
    components: {
      Swiper,
      SwiperSlide
    },
    data() {
      return {
        swiperOptionTop: {
          loop: true,
          loopedSlides: 5, // looped slides should be the same
          spaceBetween: 10,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          },
          lazy: {
            loadPrevNext: true
          },
        },
        swiperOptionThumbs: {
          loop: true,
          loopedSlides: 5, // looped slides should be the same
          spaceBetween: 10,
          centeredSlides: true,
          slidesPerView: 'auto',
          touchRatio: 0.2,
          slideToClickedSlide: true ,
        } ,
        picData : [
          'https://dixcel.cn/prod/2016日本SuperGT-team studie/1.jpg',
          'https://dixcel.cn/prod/2016日本SuperGT-team studie/2.jpg',
          'https://dixcel.cn/prod/2016日本SuperGT-team studie/3.jpg',
          'https://dixcel.cn/prod/2016日本SuperGT-team studie/4.jpg',
          'https://dixcel.cn/prod/2016日本SuperGT-team studie/5.jpg',
          'https://dixcel.cn/prod/2016日本SuperGT-team studie/6.jpg',
          'https://dixcel.cn/prod/2016日本SuperGT-team studie/7.jpg',
          'https://dixcel.cn/prod/2016日本SuperGT-team studie/8.jpg',
          'https://dixcel.cn/prod/2016日本SuperGT-team studie/9.jpg',
          'https://dixcel.cn/prod/2016日本SuperGT-team studie/10.jpg',
          'https://dixcel.cn/prod/2016日本SuperGT-team studie/11.jpg',
          'https://dixcel.cn/prod/2016日本SuperGT-team studie/12.jpg',
          'https://dixcel.cn/prod/2016日本SuperGT-team studie/13.jpg',
          'https://dixcel.cn/prod/2016日本SuperGT-team studie/14.jpg',
          'https://dixcel.cn/prod/2016日本SuperGT-team studie/15.jpg',
          'https://dixcel.cn/prod/2016日本SuperGT-team studie/16.jpg',
          'https://dixcel.cn/prod/2016日本SuperGT-team studie/17.jpg',
          'https://dixcel.cn/prod/2016日本SuperGT-team studie/18.jpg',
          'https://dixcel.cn/prod/2016日本SuperGT-team studie/19.jpg',
          'https://dixcel.cn/prod/2016日本SuperGT-team studie/20.jpg',
          'https://dixcel.cn/prod/2016日本SuperGT-team studie/21.jpg',
          'https://dixcel.cn/prod/2016日本SuperGT-team studie/22.jpg',
          'https://dixcel.cn/prod/2016日本SuperGT-team studie/23.jpg',
          'https://dixcel.cn/prod/2016日本SuperGT-team studie/24.jpg',
          'https://dixcel.cn/prod/2016日本SuperGT-team studie/25.jpg',
          'https://dixcel.cn/prod/2016日本SuperGT-team studie/26.jpg',
          'https://dixcel.cn/prod/2016日本SuperGT-team studie/27.jpg',
          'https://dixcel.cn/prod/2016日本SuperGT-team studie/28.jpg',
          'https://dixcel.cn/prod/2016日本SuperGT-team studie/29.jpg',
          'https://dixcel.cn/prod/2016日本SuperGT-team studie/30.jpg',
          'https://dixcel.cn/prod/2016日本SuperGT-team studie/31.jpg',
          'https://dixcel.cn/prod/2016日本SuperGT-team studie/32.jpg',
          'https://dixcel.cn/prod/2016日本SuperGT-team studie/33.jpg',
          'https://dixcel.cn/prod/2016日本SuperGT-team studie/34.jpg',
          'https://dixcel.cn/prod/2016日本SuperGT-team studie/35.jpg',
          'https://dixcel.cn/prod/2016日本SuperGT-team studie/36.jpg',
          'https://dixcel.cn/prod/2016日本SuperGT-team studie/37.jpg',
          'https://dixcel.cn/prod/2016日本SuperGT-team studie/38.jpg',
          'https://dixcel.cn/prod/2016日本SuperGT-team studie/39.jpg',
          'https://dixcel.cn/prod/2016日本SuperGT-team studie/40.jpg',
          'https://dixcel.cn/prod/2016日本SuperGT-team studie/41.jpg',
          'https://dixcel.cn/prod/2016日本SuperGT-team studie/42.jpg',
          'https://dixcel.cn/prod/2016日本SuperGT-team studie/43.jpg',
          'https://dixcel.cn/prod/2016日本SuperGT-team studie/44.jpg',
          'https://dixcel.cn/prod/2016日本SuperGT-team studie/45.jpg',
          'https://dixcel.cn/prod/2016日本SuperGT-team studie/46.jpg',
          'https://dixcel.cn/prod/2016日本SuperGT-team studie/47.jpg',
          'https://dixcel.cn/prod/2016日本SuperGT-team studie/48.jpg',
          'https://dixcel.cn/prod/2016日本SuperGT-team studie/49.jpg',
          'https://dixcel.cn/prod/2016日本SuperGT-team studie/50.jpg',
          'https://dixcel.cn/prod/2016日本SuperGT-team studie/51.jpg',
          'https://dixcel.cn/prod/2016日本SuperGT-team studie/52.jpg',
        ]
      }
    },
    mounted() {
      this.$nextTick(() => {
        const swiperTop = this.$refs.swiperTop.$swiper
        const swiperThumbs = this.$refs.swiperThumbs.$swiper
        swiperTop.controller.control = swiperThumbs
        swiperThumbs.controller.control = swiperTop
      })
    }
  }
</script>

<style lang="stylus" scoped>
  .container
    background-color : #000
    .box_one
      width: 100%;

    .box_bottom
      width: 100%;
      background-color #000


  .main {
    margin-bottom: 5px;
    width: 1003px;
    background-color: #fff;
    margin: 0 auto;
    position: relative;
    box-sizing: border-box;
    padding: 62px 50px 52px;
  }

  .thumb-example {
    height: 680px;
    background-color: $black;
  }
  .swiper {
    .swiper-slide {
      background-size: 100%;
      background-position: center center;
      background-repeat no-repeat
    }
    &.gallery-top {
      height: 80%;
      width: 100%;
    }
    &.gallery-thumbs {
      height: 20%;
      box-sizing: border-box;
      padding: $gap 0;
    }
    &.gallery-thumbs .swiper-slide {
      width: 20%;
      height: 100%;
      opacity: 0.4;
    }
    &.gallery-thumbs .swiper-slide-active {
      opacity: 1;
    }
  }
</style>
